<template>
  <div class="invoice-create">
    <el-card class="create-card">
      <el-steps :active="curStep" finish-status="success" :align-center="true">
        <el-step title="选择待开票数据"></el-step>
        <el-step title="确定发票信息和地址"></el-step>
      </el-steps>
      <div class="invoice-block" v-if="curStep === 0">
        <el-table v-if="invoiceMakeType == '1'" :data="expenseData"  @selection-change="handleSelectionChange" :row-key="getRowKeys" ref="invoiceTable">
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
            <el-table-column label="账单标记">
              <template slot-scope="scope">
                {{scope.row.dateTag}}
              </template>
            </el-table-column>
            <el-table-column prop="createDate" label="创建时间" >
              <template slot-scope="scope">
                {{scope.row.createDate | formatDateTime}}
              </template>
            </el-table-column>
            <el-table-column prop="cashAmount" label="现金支付金额"></el-table-column>

        </el-table>
        <el-table v-else :data="payLogData"  @selection-change="handleSelectionChange" :row-key="getRowKeys" ref="invoiceTable">
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>

          <el-table-column label="支付方式">
            <template slot-scope="scope">
                <span v-if="scope.row.payType == 11">微信支付</span>
                <span v-if="scope.row.payType == 21">支付宝</span>
              <span v-if="scope.row.payType == 41">后台储值</span>
            </template>
          </el-table-column>
          <el-table-column label="支付金额">
            <template slot-scope="scope">
              {{scope.row.amount/100 }}
            </template>
          </el-table-column>
          <el-table-column label="支付时间">
            <template slot-scope="scope">
              {{scope.row.createDate | formatDate}}
            </template>
          </el-table-column>
       </el-table>
        <el-row type="flex" justify="left" style="margin-top: 20px;">
          <!-- 勾选的开票金额大于0, 才可以进行到下一步 -->
          <el-button :disabled="invoiceAmount<=0" type="primary"  @click="handleNext" size="small">下一步</el-button>&nbsp;&nbsp;
          <div>
            <p style="margin: 0;line-height: 28px;">待开票金额：
            <span style="font-size: 24px;color: #67C23A;">￥{{ invoiceAmount }}<span v-if="$route.query.cutGiftAmount > 0">-{{ $route.query.cutGiftAmount }}</span></span>&nbsp;
            <span>已选{{this.mutTable.length}}个订单共￥{{invoiceAmount - $route.query.cutGiftAmount}}</span></p>
          </div>

          <!-- 欠票金额￥ 0.00 -->
        </el-row>
        <PageComponent ref="pageInfo"></PageComponent>
      </div>
      <div class="invoice-block" v-if="curStep === 1">
        <p class="part-text">开票主体：<span>平行云科技（北京）有限公司</span></p>
        <el-row>
          <span>发票类型：</span>
          <el-select v-model="invoiceType" size="small" @change="invoiceSendType=''">
            <!-- 登录用户为企业，才能开增值税专用发票 1个人 2企业 -->
            <el-option :disabled="user.role===1" label="增值税专用发票" :value="1"></el-option>
            <el-option label="增值税普通发票" :value="0"></el-option>
          </el-select>
        </el-row>
        <el-row style="margin-top: 10px;">
          <span>发票性质：</span>
          <el-select v-model="invoiceSendType" size="small" @change="invoiceSendTypeChange">
            <!-- 当可开发票金额小于1000时 就只能开 电子-->
            <!-- isElectricOnly为true，表示只能开电子发票 -->
            <el-option :disabled="isElectricOnly" label="纸质" :value="0"></el-option>
            <!-- 发票类型为-“增值税专用发票” 就只能开 纸质 -->
            <el-option :disabled="invoiceType===1" label="电子" :value="1"></el-option>
          </el-select>
          <el-tooltip effect="light" placement="top-start">
              <div slot="content" class="tip-info">
                勾选的开票金额大于1000元才可以开具纸质发票
              </div>
              <i class="el-icon-question tip-icon"></i>
            </el-tooltip>
        </el-row>
        <el-row style="margin-top: 10px;">
          <span>发票抬头：</span>
          <span>{{invoiceForm? invoiceForm.title: ''}}</span>
        </el-row>
        <p v-if="invoiceForm.title" style="color:#E6A23C;">注意：请核实发票信息是否正确，如果不正确请前往 <router-link to="/invoice/info">发票信息管理</router-link> 修改</p>
        <p v-else style="color:#E6A23C;">注意：还没有发票信息？ <router-link to="/invoice/info?type=add">添加发票信息</router-link></p>
        <el-divider></el-divider>
        <!-- <el-descriptions class="margin-top" :column="4" size="small">
          <el-descriptions-item label="开票内容">巴拉巴拉</el-descriptions-item>
          <el-descriptions-item label="税率">6%</el-descriptions-item>
          <el-descriptions-item label="规格型号">苏州市</el-descriptions-item>
          <el-descriptions-item label="数量"> 1号</el-descriptions-item>
        </el-descriptions> -->
        <el-descriptions class="margin-top" :column="2" size="small" direction="vertical" >
          <el-descriptions-item label="备注">
            <el-input class="note-textarea" type="textarea" style="max-width: 430px;" v-model="note" placeholder="该备注信息会展示在发票上，如有需要请录入，否则无需录入任何信息。"></el-input>
            <br/>
            <span style="display: inline-block;margin-top: 5px;color:#333;">建议不要超过25个汉字或50个（数字+字母），否则盖章的时候有可能压到。</span>
          </el-descriptions-item>
          <el-descriptions-item v-if="invoiceSendType===0" label="纸质票邮寄地址">
            <p class="address-info">取件人：{{addressInfo.name}}</p>
            <p class="address-info">联系电话：{{addressInfo.mobile}}</p>
            <p class="address-info">邮寄地址：{{addressInfo.address}}</p>
            <router-link v-if="invoiceSendType===0&&!addressInfo.address" to="/invoice/info" style="color:#11A49F;">添加邮寄地址</router-link>
            <el-button type="text" v-if="invoiceSendType===0&&addressInfo.address" @click="openAddressChooseDialog">选择邮寄地址</el-button>
          </el-descriptions-item>
          <el-descriptions-item v-if="invoiceSendType===1" label="电子邮箱地址">
            <p class="address-info">{{email}}</p>
            <router-link v-if="invoiceSendType===1&&email === ''" to="/invoice/info" style="color:#11A49F;">添加邮箱</router-link>
            <el-button type="text" v-if="invoiceSendType===1&&email !== ''" @click="openEmailChooseDialog">选择邮箱</el-button>
          </el-descriptions-item>
        </el-descriptions>
        <el-row type="flex" justify="center" style="margin-top: 20px;">
          <template v-if="operation === 'reapply'">
            <el-button type="primary" size="small" v-loading="loading" :disabled="loading" @click="reapplySubmit">重新索取发票</el-button>
          </template>
          <template v-else>
            <el-button @click="handlePreFn" size="small">上一步</el-button>
            <el-button type="primary" size="small" v-loading="loading" :disabled="loading" @click="submit">索取发票</el-button>
          </template>
        </el-row>
      </div>
    </el-card>
    <AddressChoose
      :addressChooseDialog="addressChooseDialog"
      :addressData="addressData"
      @addressChoseClose="addressChoseClose"
      @addressChooseSend="addressChooseReceive" />
    <EmailChoose
      :emailChooseDialog="emailChooseDialog"
      :emailData="emailData"
      @emailChoseClose="emailChoseClose"
      @emailChooseSend="addressChooseReceive"/>
  </div>
</template>
<script>
import PageComponent from "@/components/pageInfo/PageComponent";
import AddressChoose from "./components/addressChoose.vue"
import EmailChoose from "./components/emailChoose.vue"
export default {
  components: {
    PageComponent,
    AddressChoose,
    EmailChoose
  },
  data() {
    return {
      invoiceMakeType :this.$route.query.invoiceMakeType,
      curStep: 0, //步骤条
      invoiceForm: {
        title: ''
      }, // 发票信息
      mutTable: [], //勾选开票数据
      expenseData: [],//  待开票列表--后开票
      payLogData: [],//待开票列表--预开票
      invoiceType: '', // 专用发票、普通发票
      invoiceSendType: '',// 电子、纸质
      isElectricOnly: this.$route.query.isElectricOnly, // 如果为true，表示只能开电子发票
      addressData: [], // 寄送地址列表
      emailData: [], // 邮箱地址列表
      note: '', //备注
      addressInfo: {}, // 寄送地址（默认）包含了姓名 电话 地址
      email: '', // 邮箱（默认）
      addressChooseDialog: false, //选择邮寄地址弹窗
      emailChooseDialog: false, // 选择邮箱弹窗
      operation: '', // 'reapply'为重新申请操作
      reapplyInvoiceId: '',//重新申请发票ID
      reapplyInvoiceAmount: 0,// 重新申请时存储一下发票金额，用来直接submit，正常新索取发票时金额是根据选中的数据computed计算的
      loading: false,
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    invoiceAmount() {
      let amount = 0;
      this.mutTable.forEach(item => {
        if(this.invoiceMakeType == '1'){
          amount = this.cal.add(amount, item.cashAmount);
        }else {
          amount = this.cal.add(amount, item.amount/100);
        }

      })
      return amount;
    }
  },
  mounted() {

    //后开发票时，通过查询账单数据开发票
    if(this.invoiceMakeType == '1'){
      // 如果是重新申请操作，不需要获取待开票数据，直接查询第一次申请选择的开票数据
      // 同时步骤条直接显示第二步
      if(this.$route.query.operation === 'reapply') {
        this.curStep =1; // 步骤条显示第二步，可以修改发票类型信息等数据
        this.operation = 'reapply';
        // 重新申请--获取已经勾选的订单数据
        this.getReapplyInvoiceList();
        // 获取发票信息
        this.getReapplyInvoiceData();
        this.getIvoiceData();
      } else {
        this.$refs.pageInfo.initPagenator(this.getExpenseList, 10);
        this.getExpenseList();
      }
    }else {
      //预开发票时，通过查询账单数据开发票
      if(this.$route.query.operation === 'reapply') {
        this.curStep =1; // 步骤条显示第二步，可以修改发票类型信息等数据
        this.operation = 'reapply';
        // 重新申请--获取已经勾选的订单数据
        this.getReapplyPayLogList();
        // 获取发票信息
        this.getReapplyInvoiceData();
        this.getIvoiceData();
      } else {
        this.$refs.pageInfo.initPagenator(this.getPayLogList, 10);
        this.getPayLogList();
      }
    }

  },
  methods: {
    // 获取发票信息
    getIvoiceData() {
      let params = {
        userId: this.user.userId
      }
      this.getRequest('/ofc/getPersonalInvoiceInfo',params).then(res => {
        if(res.status == 200) {
          if(res.data.code == 1000) {
            this.invoiceForm = Object.assign(this.invoiceForm,res.data.result);
            // 赋值 ->默认发票类型
            if(this.operation === '')this.invoiceType = res.data.result? res.data.result.defaultInvoiceType: '';
          }
        }
      })
    },
    // 获取待开票账单数据
    getExpenseList() {
      let params = {
        userId: this.user.userId,
        page: this.$refs.pageInfo.currentPage,
        pageSize: 10,
        invoiceFlag: 0
      }
      this.getRequest('/ofc/expenseAggregate/search',params).then(res => {
        if(res.status == 200) {
          if(res.data.code == 1000) {
            this.expenseData = res.data.result.records;
            this.$refs.pageInfo.outputPagenator(res.data.result.total);
          }
        }
      })
    },
    // 获取待开票支付数据
    getPayLogList() {
      let params = {
        userId: this.user.userId,
        invoiceFlag:0,
        invoiceAmountCountedFlag: 1,
        page: this.$refs.pageInfo.currentPage,
        pageSize: 10,
        nePayType: "31"
      }
      this.getRequest('/ofc/payLog/search',params).then(res => {
        if(res.status == 200) {
          if(res.data.code == 1000) {
            this.payLogData = res.data.result.records;
            this.$refs.pageInfo.outputPagenator(res.data.result.total);
          }
        }
      })
    },
    // 勾选表格
    handleSelectionChange(val) {
      this.mutTable = val;
    },
    //下一步
    handleNext() {
      if(this.mutTable.length == 0) {
        this.$message.warning('请选择待开票数据！');
      } else {
        let checkAmount = 0;
        this.mutTable.forEach(item => {
          if(item.cashAmount) checkAmount+=item.cashAmount;

        })
        // 勾选的开票金额小于1000，只能开电子发票
        if(checkAmount <1000) {
          this.isElectricOnly = true;
        } else {
          this.isElectricOnly = false;
        }
        this.getIvoiceData(); // 获取发票信息
        this.curStep++;
      }
    },
    // 发票类型更改
    invoiceSendTypeChange(val) {
      if(val === 0) { // 纸质
        this.getAddressData();
      } else { //val === 1 电子
        this.getEmailData();
      }
    },
    // 打开选择地址弹窗
    openAddressChooseDialog() {
      this.addressChooseDialog = true;
    },
    // 关闭选择地址弹窗
    addressChoseClose() {
      this.addressChooseDialog = false;
    },
    // 接收选择的地址
    addressChooseReceive(val) {
      this.addressInfo = val;
      this.addressChooseDialog = false;
    },
    // 打开选择邮箱弹窗
    openEmailChooseDialog() {
      this.emailChooseDialog = true;
    },
    // 关闭选择邮箱弹窗
    emailChoseClose() {
      this.emailChooseDialog = false;
    },
    // 接收选择的邮箱
    addressChooseReceive(val) {
      this.email = val.email;
      this.emailChooseDialog = false;
    },
    // 获取寄送地址数据
    getAddressData() {
      let params = {
        userId: this.user.userId
      }
      this.getRequest('/uac/address/search',params).then(res => {
        if(res.status == 200) {
          if(res.data.code == 1000) {
            if(res.data.result.records.length) {
              this.addressData = res.data.result.records;
              // 新增时，才赋值默认的数据
              if(!(this.operation==='reapply')) {
                if(res.data.result.records.length===1) {
                  // 如果只有一条数据，直接认为是默认的
                  this.addressInfo =this.addressData[0];
                } else {
                  let info=this.addressData.find(item => item.defaultFlag===1);
                  this.addressInfo = info?info.address:this.addressData[0];
                }
              }
            }
          }
        }
      })
    },
    // 获取邮箱列表
    getEmailData() {
      let params = {
        userId: this.user.userId
      }
      this.getRequest('/uac/email/search',params).then(res => {
        if(res.status == 200) {
          if(res.data.code == 1000) {
            if(res.data.result.records.length) {
              this.emailData = res.data.result.records;
              // 新增时，才赋值默认的数据
              if(!(this.operation==='reapply')) {
                if(res.data.result.records.length===1) {
                  // 如果只有一条数据，直接认为是默认的
                  this.email =this.emailData[0].email;
                } else {
                  let info = this.emailData.find(item => item.defaultFlag===1);
                  this.email = info?info.email:this.emailData[0].email;
                }
              }
            }
          }
        }
      })
    },
    // 上一步
    handlePreFn() {
      this.curStep--;
      this.mutTable = [];
      this.$nextTick(() => {
        this.$refs.pageInfo.initPagenator(this.getExpenseList, 10);
        var queryStr = JSON.parse(JSON.stringify(this.$route.query));
        queryStr.page = 1;
        this.$router.push({query: queryStr});
        this.getExpenseList();
      })
    },
    // 验证信息
    // title，titleType，defaultInvoiceType，creditCode，bankName，bankAccount，
    // registPlaceAddress，registFixedPhone，taxpayerQualification，businessLicense，accountOpeningPermit，specialTicketInfo
    validInvoiceInfo(validType) {
      let flag = true;
      if(validType === 1) { //增值税专用发票
        if(!this.invoiceForm.bankName){this.$message.warning('发票信息缺少开户银行名称！');flag = false;return false};
        if(!this.invoiceForm.bankAccount){this.$message.warning('发票信息缺少基本开户账号！');flag = false;return false};
        if(!this.invoiceForm.registPlaceAddress){this.$message.warning('发票信息缺少注册场所地址！');flag = false;return false};
        if(!this.invoiceForm.registFixedPhone){this.$message.warning('发票信息缺少注册固定电话！');flag = false;return false};
        if(!this.invoiceForm.taxpayerQualification){this.$message.warning('发票信息缺少一般纳税人资质！');flag = false;return false};
        if(!this.invoiceForm.businessLicense){this.$message.warning('发票信息缺少营业执照复印件！');flag = false;return false};
        if(!this.invoiceForm.accountOpeningPermit){this.$message.warning('发票信息缺少开户许可证！');flag = false;return false};
        if(!this.invoiceForm.specialTicketInfo){this.$message.warning('发票信息缺少开专票信息！');flag = false;return false};
      }
      if(!this.invoiceForm.title){this.$message.warning('发票信息缺少发票抬头！');flag = false;return false};
      if(this.invoiceForm.titleType==undefined||this.invoiceForm.titleType==null){this.$message.warning('发票信息缺少抬头类型！');flag = false;return false};
      if(this.invoiceForm.defaultInvoiceType==undefined||this.invoiceForm.defaultInvoiceType==null){this.$message.warning('发票信息缺少默认发票类型！');flag = false;return false};
      if(!this.invoiceForm.creditCode){this.$message.warning('发票信息缺少统一社会信用代码！');flag = false;return false};
      if(this.invoiceSendType === 0) { //纸质需要验证 姓名 地址，手机号
        if(!this.addressInfo.address) {this.$message.warning('缺少邮寄地址-地址信息！');flag = false;return false}
        if(!this.addressInfo.name) {this.$message.warning('缺少邮寄地址-取件人信息！');flag = false;return false}
        if(!this.addressInfo.mobile) {this.$message.warning('缺少邮寄地址-联系电话信息！');flag = false;return false}
      } else if(this.invoiceSendType === 1) {//纸质需要验证 邮箱
        if(!this.email) {this.$message.warning('缺少电子邮箱信息！');flag = false;return false}
      }
      return flag;
    },
    // 保存
    submit() {
      if(this.invoiceType === '') {
        this.$message.warning('请选择发票类型！');
        return;
      }
      if(this.invoiceSendType === '') {
        this.$message.warning('请选择发票形式！');
        return;
      }
      if(this.note.length > 256){
        this.$message.warning('备注长度超长！');
        return;
      }
      if(this.validInvoiceInfo(this.invoiceType)) {
        let params = {
          invoiceType: this.invoiceType,
          invoiceSendType: this.invoiceSendType,
          note: this.note,
          invoiceAmount: this.invoiceAmount - this.$route.query.cutGiftAmount, // 发票金额
          cutGiftAmount: this.$route.query.cutGiftAmount,
          invoiceInfoId: this.invoiceForm.id, // 发票信息ID
        }
        if(this.invoiceSendType === 0) {
          params.address = this.addressInfo.address;
          params.name = this.addressInfo.name;
          params.mobile = this.addressInfo.mobile;
        } else if(this.invoiceSendType === 1) {
          params.email = this.email;
        }
        if(this.invoiceMakeType == '1'){
          /*params.ofcExpenseIdList = this.mutTable.map(item => item.id);*/
          params.ofcExpenseAggregateIdList = this.mutTable.map(item => item.id);
          params.ofcPayLogIdList = [];
        }else {
          params.ofcExpenseIdList = [];
          params.ofcPayLogIdList = this.mutTable.map(item => item.id);
        }


        this.loading = true;
        this.postRequestJson('/ofc/invoiceLog/add',params).then(res => {
          this.loading = false;
          if(res.status === 200) {
            if(res.data.code === 1000) {
              this.$message.success("索取发票成功！");
              this.$router.push('/invoice');
            }else {
              this.$message.error(res.data.message);
            }
          }
        })
      }
    },
    getRowKeys(row) {
      return row.id; // 每条数据的唯一识别值
    },
    // 重新申请--获取已经勾选的订单数据
    getReapplyInvoiceList() {
      let params = {
        invoiceLogId: this.$route.query.invoiceLogId,
        page: 1,
        pageSize: 10000, // 获取全部的勾选订单列表
      }
      this.getRequest("/ofc/expense/search", params).then(res => {
        if(res.status == 200) {
          let  data = res.data;
          if(data.code == 1000) {
            this.mutTable = data.result.records;
          } else {
            this.$message.error(data.message)
          }
        }
      })
    },
    // 重新申请--获取已经勾选的支付数据
    getReapplyPayLogList() {
      let params = {
        invoiceLogId: this.$route.query.invoiceLogId,
        page: 1,
        pageSize: 10000, // 获取全部的勾选订单列表
      }
      this.getRequest("/ofc/payLog/search", params).then(res => {
        if(res.status == 200) {
          let  data = res.data;
          if(data.code == 1000) {
            this.mutTable = data.result.records;
          } else {
            this.$message.error(data.message)
          }
        }
      })
    },
    // 获取发票信息
    getReapplyInvoiceData() {
      let params = {
        id: this.$route.query.invoiceLogId
      }
      this.getRequest('/ofc/invoiceLog/search',params).then(res => {
        console.log(res)
         if(res.status == 200) {
          if(res.data.code == 1000) {
            let list = res.data.result.records.map(item => {
              return Object.assign(item,{
                createDateSelf: this.formatDateTime(item.createDate),
                invoiceTypeSelf: item.invoiceType === 0? '增值税普通发票':(item.invoiceType === 1?'增值税专用发票':''),
                invoiceSendTypeSelf: item.invoiceSendType === 0? '纸质':(item.invoiceSendType === 1?'电子':''),
                // statusSelf: this.statusObj[item.status],
              })
            })
            let invoiceInfoData = list[0];
            this.invoiceType = invoiceInfoData.invoiceType;
            this.invoiceSendType = invoiceInfoData.invoiceSendType;
            this.note = invoiceInfoData.note;
            this.reapplyInvoiceAmount = invoiceInfoData.invoiceAmount;
            if(this.reapplyInvoiceAmount < 1000){
              this.isElectricOnly = true;
            }else {
              this.isElectricOnly = false;
            }
            console.log(this.isElectricOnly)
            this.invoiceForm.id = invoiceInfoData.invoiceInfoId;
            this.reapplyInvoiceId = invoiceInfoData.id;
            if(this.invoiceSendType === 0) {
              this.addressInfo = {
                address: invoiceInfoData.address,
                name: invoiceInfoData.name,
                mobile: invoiceInfoData.mobile
              }
            } else if(this.invoiceSendType === 1) {
              this.email = invoiceInfoData.email
            }
            this.invoiceSendTypeChange(this.invoiceSendType);
          }
         }
      })
    },
    // 重新索取发票
    reapplySubmit() {
      if(this.invoiceType === '') {
        this.$message.warning('请选择发票类型！');
        return;
      }
      if(this.invoiceSendType === '') {
        this.$message.warning('请选择发票形式！');
        return;
      }
      if(this.validInvoiceInfo(this.invoiceType)) {
        let params = {
          invoiceType: this.invoiceType,
          invoiceSendType: this.invoiceSendType,
          note: this.note,
          invoiceAmount: this.reapplyInvoiceAmount, // 发票金额
          invoiceInfoId: this.invoiceForm.id, // 发票信息ID
          id: this.reapplyInvoiceId
        }
        if(this.invoiceSendType === 0) {
          params.address = this.addressInfo.address;
          params.name = this.addressInfo.name;
          params.mobile = this.addressInfo.mobile;
        } else if(this.invoiceSendType === 1) {
          params.email = this.email;
        }
        params.ofcExpenseIdList = this.mutTable.map(item => item.id);
        this.loading = true;
        this.postRequestJson('/ofc/invoiceLog/reapply',params).then(res => {
          this.loading = false;
          if(res.status === 200) {
            if(res.data.code === 1000) {
              this.$message.success("重新索取发票成功！");
              this.$router.push('/invoice');
            }else {
              this.$message.error(res.data.message);
            }
          }
        })
      }
    },
  }
}
</script>
<style lang='scss' scoped>
  .invoice-create {
    .create-card {
      margin-top: 15px;
      .invoice-block {
        margin-top: 20px;
        .part-text {
          color: #303133;
          >span {
             color: #333;
             font-size: 18px;
             font-weight: bold;
          }
        }
      }
      .address-info{
        margin: 3px 0;
      }
      ::v-deep .note-textarea.el-textarea .el-textarea__inner {
        font-size: 12px!important;
      }
    }
  }
</style>
